// Imports only ./segmentTypes, which imports nothing, so a browser bundle can deep-import this module (client-v2 does).
import { SEGMENT_TYPE } from './segmentTypes';

/**
 * @param {{ type?: string | null }} [segment]
 * @returns {boolean}
 */
export const isValidActivityParent = (segment = {}) => segment.type === SEGMENT_TYPE.STAY || segment.type === SEGMENT_TYPE.POINT;

/**
 * Folds each service segment into the `extras` of the preceding stay or point parent.
 * Returns shallow copies and leaves the input segments unchanged.
 * @template {{ type?: string | null }} T
 * @param {T[]} segments
 * @returns {Array<T & { extras?: T[] }>}
 */
export const associateServiceSegmentsToParent = segments => {
  /** @type {(T & { extras: T[] }) | null} */
  let lastParent = null;
  /** @type {Array<T & { extras?: T[] }>} */
  const result = [];
  for (const segment of segments) {
    if (isValidActivityParent(segment)) {
      lastParent = { ...segment, extras: [] };
      result.push(lastParent);
      continue;
    }
    if (segment.type === SEGMENT_TYPE.SERVICE && lastParent) {
      lastParent.extras.push(segment);
      continue;
    }
    result.push({ ...segment });
  }
  return result;
};
